<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import store from '@/store';
// import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'MechanicPage',
  // beforeRouteEnter(to, from, next) {
  //   checkRouteAccess('', next);
  // },
  beforeRouteEnter(to, from, next) {
    store.commit('global/setRole', null, { root: true });
    next();
  },
};
</script>

<style lang="scss" scoped></style>
